import { service } from '@ember/service';
import ApplicationAdapter from './application';
import getSegmentHeaders from 'client-portal/utils/segment-header';

export default class PaymentLinkSession extends ApplicationAdapter {
  @service analytics;

  get headers() {
    return {
      ...super.headers,
      ...getSegmentHeaders(this.analytics),
    };
  }

  urlForCreateRecord() {
    return `${this.buildURL()}/sessions/payment-link`;
  }

  currentSession() {
    let url = `${this.buildURL()}/sessions/payment-link`;

    return this.ajax(url, 'GET');
  }
}
